// extracted by mini-css-extract-plugin
module.exports = {"w1puqmho":"w1puqmho"};